import React, { MouseEvent, ReactElement } from 'react';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';

import { clearRightClickedItems } from '../../../../store/slices/viewportSlice';
import { useAppDispatch } from '../../../hooks';

export function SceneMenuItem(props: {
  text: string;
  onClick: (event: MouseEvent) => void;
  icon?: ReactElement;
  id?: string;
  selected?: boolean;
  disabled?: boolean;
}) {
  const dispatch = useAppDispatch();

  return (
    <MenuItem
      disabled={props.disabled}
      selected={props.selected}
      id={props.id}
      onClick={(event) => {
        props.onClick(event);

        if (!event.isDefaultPrevented()) {
          dispatch(clearRightClickedItems());
        }
      }}
    >
      {props.icon && <ListItemIcon>{props.icon}</ListItemIcon>}
      <ListItemText>{props.text}</ListItemText>
    </MenuItem>
  );
}
